import { Button } from '@heroui/react'
import { MapPin } from 'lucide-react'
import { useTranslations } from 'use-intl'
import { POPULAR_HOTSPOTS } from '../../lib/area-constants'

interface IAreaSelectorProps {
  onSelect: (lat: number, lng: number) => void
  currentLat?: number
  currentLng?: number
}

export function AreaSelector({ onSelect, currentLat, currentLng }: Readonly<IAreaSelectorProps>) {
  const t = useTranslations('discovery.hotspots')

  return (
    <div className="flex flex-col gap-2">
      <h4 className="text-xs font-bold uppercase tracking-wider text-stone-400 dark:text-stone-500 mb-1 flex items-center gap-1.5">
        <MapPin className="w-3.5 h-3.5" />
        {t('title')}
      </h4>
      <div className="flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 lg:-mx-0 lg:px-0 no-scrollbar">
        {POPULAR_HOTSPOTS.map((hotspot) => {
          const isActive =
            currentLat !== undefined &&
            currentLng !== undefined &&
            Math.abs(currentLat - hotspot.lat) < 0.001 &&
            Math.abs(currentLng - hotspot.lng) < 0.001

          return (
            <Button
              key={hotspot.id}
              size="sm"
              variant={isActive ? 'primary' : 'ghost'}
              className={`text-xs rounded-full shrink-0 font-semibold shadow-sm transition-all active:scale-95 ${
                isActive
                  ? 'bg-primary text-white shadow-primary/20'
                  : 'bg-white dark:bg-stone-850 hover:bg-stone-100 dark:hover:bg-stone-800 border border-stone-200 dark:border-stone-800'
              }`}
              onPress={() => onSelect(hotspot.lat, hotspot.lng)}
            >
              {t(hotspot.nameKey)}
            </Button>
          )
        })}
      </div>
    </div>
  )
}
